export interface SseEvent {
  /** The `event:` field, when the server names the event. */
  event?: string
  /** All `data:` lines of the event, joined with `\n`. */
  data: string
}

/**
 * Incremental `text/event-stream` parser.
 *
 * Chunks arrive cut anywhere — mid-line, between `\r` and `\n` — so a partial
 * line is held until its line break arrives. Lines end with LF or CRLF; an
 * event ends at a blank line.
 */
export function createSseParser(onEvent: (event: SseEvent) => void) {
  let buffer = ''
  let data: string[] = []
  let event: string | undefined

  const dispatch = () => {
    if (data.length > 0) {
      onEvent(
        event ? { event, data: data.join('\n') } : { data: data.join('\n') }
      )
    }
    data = []
    event = undefined
  }

  const line = (text: string) => {
    if (text === '') {
      dispatch()
      return
    }
    if (text.startsWith(':')) {
      return
    }

    const colon = text.indexOf(':')
    const field = colon === -1 ? text : text.slice(0, colon)
    let value = colon === -1 ? '' : text.slice(colon + 1)
    if (value.startsWith(' ')) {
      value = value.slice(1)
    }

    if (field === 'data') {
      data.push(value)
    } else if (field === 'event') {
      event = value
    }
  }

  return {
    push(chunk: string) {
      buffer += chunk
      const lines = buffer.split(/\r?\n/)
      buffer = lines.pop() ?? ''
      for (const text of lines) {
        line(text)
      }
    }
  }
}
